import React from "react";
import { Link } from "gatsby";
import PropTypes from "prop-types";
import tw, { styled } from "twin.macro";

const TabContainer = tw.div`md:py-2 md:my-2 flex flex-col md:flex-row md:my-0 md:space-x-8 font-bold`;
const Tab = styled(Link)(({ isActive }) => [
  tw`py-2 tracking-wide inline-block text-gray-700 hocus:text-blue-700 uppercase text-sm transition duration-200 ease-in-out`,
  isActive && tw`md:border-b-4 border-blue-900 hocus:border-blue-700 text-blue-900 font-bold`
])

const Tabs = ({ tabs }) => {
  return (
    <TabContainer>
      {tabs.map(tab => (
        <Tab key={tab.label} isActive={tab.active} to={tab.to}>
          {tab.label}
        </Tab>
      ))}
    </TabContainer>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      active: PropTypes.bool,
      to: PropTypes.string
    })
  ).isRequired
};

export default Tabs;
